import {
  ACTION_GET_DEFAULT_EXPENSE_POLICY,
  ACTION_GET_DEFAULT_EXPENSE_POLICY_SUCCESS,
  ACTION_GET_DEFAULT_EXPENSE_POLICY_FAILURE,
  API_CALL,
} from '../../configs/ActionTypes';

import { Dispatch } from 'redux';

export function getDefaultExpensePolicy(organizationId: string) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch(requestStarted());

    //Dispatch the api call request.
    dispatch({
      type: API_CALL,
      payload: {
        call: `organizations/${organizationId}/default-expense-policy`,
        method: 'get',
        data: {},
        success: (response: any) => {
          if (response.type === 'error') {
            dispatch(requestFailed(response));
          } else {
            dispatch(requestSuccess(response));
          }
        },
        fail: (error: any) => {
          dispatch(requestFailed(error));
        },
      },
    });

    return null;
  };
}

export function requestStarted() {
  return {
    type: ACTION_GET_DEFAULT_EXPENSE_POLICY,
    payload: null,
  };
}

export function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_GET_DEFAULT_EXPENSE_POLICY_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: object) {
  return {
    type: ACTION_GET_DEFAULT_EXPENSE_POLICY_FAILURE,
    payload: responseJSON,
  };
}
